import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import ScrollToTop from './components/ScrollToTop'
import CookieConsent from './components/cookie/CookieConsent'
import WalletStatusBar from './components/wallet/WalletStatusBar'
import ErrorBoundary from './components/base/ErrorBoundary'
import { WalletProvider } from './contexts/WalletContext'
import { ToastProvider } from './contexts/ToastContext'
import { ToastContainer } from './components/base/Toast'
import { useToast } from './contexts/ToastContext'
import { cookieManager } from './utils/cookieManager'
import { logger } from './utils/logger'
import { ThemeProvider } from './contexts/ThemeContext'
import { StructuredData, defaultOrganizationData, defaultWebsiteData } from './components/base/StructuredData'
import PageTransition from './components/base/PageTransition'
import { Suspense } from 'react'
import Skeleton from './components/base/Skeleton'
import AccessibilityEnhancements from './components/base/AccessibilityEnhancements'

function AppContent() {
  const { toasts, removeToast } = useToast();

  const handleCookieAccept = (preferences: any) => {
    logger.info('Cookie preferences accepted', preferences);
    
    // 如果用户同意分析Cookie，初始化Google Analytics
    if (preferences.analytics) {
      // 这里可以添加您的Google Analytics测量ID
      // cookieManager.initializeGoogleAnalytics('GA_MEASUREMENT_ID');
    }
  };

  const handleCookieReject = () => {
    logger.info('All cookies rejected except necessary ones');
    cookieManager.clearNonEssentialCookies();
  };

  return (
    <>
      <AccessibilityEnhancements />
      <ScrollToTop />
      <WalletStatusBar />
      <Suspense 
        fallback={
          <div className="min-h-screen flex items-center justify-center">
            <div className="text-center">
              <Skeleton variant="circular" width={60} height={60} className="mb-4 mx-auto" />
              <Skeleton variant="text" width={200} height={24} className="mx-auto mb-2" />
              <Skeleton variant="text" width={150} height={20} className="mx-auto" />
            </div>
          </div>
        }
      >
        <PageTransition>
          <AppRoutes />
        </PageTransition>
      </Suspense>
      <CookieConsent 
        onAccept={handleCookieAccept}
        onReject={handleCookieReject}
      />
      <ToastContainer 
        toasts={toasts} 
        onRemove={removeToast} 
      />
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <StructuredData 
          organization={defaultOrganizationData}
          website={defaultWebsiteData}
        />
        <BrowserRouter basename={__BASE_PATH__}>
          <ToastProvider>
            <WalletProvider>
              <AppContent />
            </WalletProvider>
          </ToastProvider>
        </BrowserRouter>
      </ThemeProvider>
    </ErrorBoundary>
  )
}

export default App